module.exports = __webpack_public_path__ + "img/whitedownsvg.34c33f3c.svg";